<template>
  <div class="text-center">    
    <picture
      :class="`embed-responsive embed-responsive-1by1 size-${size}`"
    >
      <slot />
      <img
        v-lazy="avatar"
        :alt="title"
        class="embed-responsive-item"
      />
    </picture>
  </div>
</template>

<script>
  export default {
    props: {
      avatar: { type: String, required: true },
      title: { type: String, default: '' },
      size: { type: String, default: 'md' }
    },
  }
</script>

<style scoped lang="scss">
  picture {
    display: inline-block;
    border-radius: 100%;
    flex-shrink: 0;
  }

  picture.size-md { 
    width: 60px; 
    height: 60px;
   }
  picture.size-lg { 
    width: 109px; 
    height: 109px; 
    }
</style>
